import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Trans, useTranslation } from "react-i18next";
import boost from "highcharts/modules/boost";
import Exporting from "highcharts/modules/exporting";
import bellcurve from "highcharts/modules/histogram-bellcurve";

boost(Highcharts);
Exporting(Highcharts);
bellcurve(Highcharts);

export default function HistogramChart({ points, visible, backCallback }) {
    const [, setIsLoading] = useState(false);
    const [chartPoints, setChartPoints] = useState([]);

    const { t } = useTranslation();

    useEffect(() => {
        setIsLoading(true);
        setChartPoints(points);
    }, [points]);

    const getOption = (graph) => {
        return {
            title: {
                text: graph.name,
            },
            xAxis: [
                {
                    title: {
                        text: graph.name,
                    },
                    alignTicks: false,
                },
            ],

            yAxis: [
                {
                    title: { text: t("frequency") },
                },
            ],

            series: [
                {
                    name: t("histogram"),
                    type: "histogram",
                    binWidth: Math.abs(graph.max - graph.min) / 10,
                    baseSeries: "s1",
                    zIndex: -1,
                },
                {
                    name: graph.name,
                    type: "scatter",
                    data: graph.points,
                    id: "s1",
                    visible: false,
                },
            ],
            exporting: {
                buttons: {
                    contextButton: {
                        menuItems: [
                            {
                                text: t("printChart"),
                                textKey: "printChart",
                                onclick: function () {
                                    this.print();
                                },
                            },
                            "separator",
                            {
                                text: t("downloadPNG"),
                                textKey: "downloadPNG",
                                onclick: function () {
                                    this.exportChart();
                                },
                            },
                            {
                                text: t("downloadJPEG"),
                                textKey: "downloadJPEG",
                                onclick: function () {
                                    this.exportChart({
                                        type: "image/jpeg",
                                    });
                                },
                            },
                            {
                                text: t("downloadPDF"),
                                textKey: "downloadPDF",
                                onclick: function () {
                                    this.exportChart({
                                        type: "application/pdf",
                                    });
                                },
                            },
                            {
                                text: t("downloadSVG"),
                                textKey: "downloadSVG",
                                onclick: function () {
                                    this.exportChart({
                                        type: "image/svg+xml",
                                    });
                                },
                            },
                        ],
                    },
                },
            },
        };
    };

    const renderChart = () => {
        if (!chartPoints || chartPoints?.length === 0) {
            return (
                <div className="relative h-24 bg-white">
                    <p className="chart-placeholder">
                        <Trans i18nKey="noDataDisplayMessage">
                            No data to display
                        </Trans>
                    </p>
                </div>
            );
        } else {
            return chartPoints.map((p, index) => (
                <div
                    key={`Histogram-${index}`}
                    className="relative bg-white mb-4"
                >
                    <div className="min-h-full">
                        <HighchartsReact
                            key={index}
                            constructorType="chart"
                            highcharts={Highcharts}
                            options={getOption(p)}
                        />
                    </div>
                </div>
            ));
        }
    };

    return (
        <>
            <div
                className={`tabs-content-items flex flex-col mb-5 ${
                    visible ? "show" : ""
                }`}
                // id="histogram-content-wrapper"
            >
                {backCallback && (
                    <button
                        className="default-transparent-btn mb-5"
                        onClick={backCallback}
                    >
                        <i className="fas fa-caret-left"></i>
                        <span className="ml-2">
                            <Trans i18nKey="goBack">Go Back</Trans>
                        </span>
                    </button>
                )}
                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow rounded bg-light-gray">
                    {/* <LoadingOverlay active={isLoading} spinner text="Loading..."> */}
                    <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
                        <div className="flex flex-wrap items-center">
                            <div className="relative w-full max-w-full flex-grow flex-1">
                                <h2 className="text-primary-blue text-xl font-semibold">
                                    <Trans i18nKey="nirHistogram">
                                        NIR Histogram
                                    </Trans>
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="p-4 flex-auto h-400-px">
                        {renderChart()}
                    </div>
                    {/* </LoadingOverlay> */}
                </div>
            </div>
        </>
    );
}
